import { Box, Button, Card, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomerList from './CustomerList'
import MainContentLayout from "../../components/Layout/MainContentLayout";
import PageHeaderLayout from "../../components/Layout/PageHeaderLayout";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import IncompleteProfileCustomerList from "./IncompleteProfileCustomerList";

export default function Customer(){
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'customer'
        });
    }, []);
    const navigate = useNavigate();
      const {tab} = useParams();
      const [tabValue, setTabValue] = useState('0');
    
      // const handleChange = (event, newValue) => {
      //   setTabValue(newValue);
      // };
      // Update tab value from URL parameter on component mount
      // useEffect(() => {
      //   if (tab && ['0', '1'].includes(tab)) {
      //     setTabValue(tab);
      //   } else {
      //     setTabValue('0');
      //     navigate('/settings/business/0');
      //     // // Optionally update URL if tab param is invalid or missing
      //     // navigate('/settings/business/0', { replace: true });
      //   }
      // }, [tab, navigate]);
      
      // Handle tab change and update URL
      const handleChange = (event, newValue) => {
        setTabValue(newValue);
        // navigate(`/settings/business/${newValue}`);
      };
    return (
        // <CustomerList/>
        <Box>
      {/* ===========page title================= */}
      <PageHeaderLayout headerTitle={'Manage Customers'}>
        <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem'}}/>} sx={{ textTransform:'capitalize' }}>
          Back
        </Button>
      </PageHeaderLayout>
      <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            sx={{ p: 0, minHeight: '40px' }}
            variant="scrollable"
            scrollButtons="auto"
          >

            <Tab value="0" label="Completed Profile" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
            <Tab value="1" label="Incomplete Profile" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
            {/* <Tab value="three" label="Item Three" /> */}
          </Tabs>
        </Box>
      </Card>
      {tabValue === '0' && <CustomerList />}
      {tabValue === '1' && <IncompleteProfileCustomerList />}
    </Box>
    )
}
